export default __webpack_public_path__ + "static/media/29_photo.c64b7ac4.jpeg";